'use client';

import Script from 'next/script';

import { envConfig } from '#app/config';

export const InitHypeLab = () => {
  const propertySlug = 'f6fe8c09d2';

  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <Script
      id="hypelab"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `!(function (h, y, p, e, l, a, b) {
      ((a = document.createElement(h)).async = !0),
      (a.src = y),
      (a.onload = function () {
        (l = { environment: p, propertySlug: e, ...l }), HypeLab.initialize(l);
      }),
      (b = document.getElementsByTagName(h)[0]).parentNode.insertBefore(a, b);
    })('script', 'https://api.hypelab.com/v1/scripts/hp-sdk.js?v=0', '${
      isDevelopment ? 'development' : 'production'
    }', '${propertySlug}', {});`,
      }}
    />
  );
};
